import * as React from "react";
// import { Spinner } from "@fluentui/react-components";
import { SpreetailHeader } from "../layout/SpreetailHeader";

// interface RefreshControlsProps {
//   onRefresh: () => Promise<void>;
//   isRefreshing: boolean;
//   isGeneratingDashboard: boolean;
//   lastUpdated: string;
//   buttonText: string;
// }

// export const RefreshControls: React.FC<RefreshControlsProps> = ({
//   onRefresh,
//   isRefreshing,
//   isGeneratingDashboard,
//   buttonText,
// }) => {
//   const disabled = isRefreshing || isGeneratingDashboard;
//   return (
//     <div className="p-0 px-5 pb-5 flex-shrink-0">
//       <button
//         onClick={onRefresh}
//         disabled={disabled}
//         className="st-refresh-btn w-full bg-[#0461FE] text-white border-none rounded-xl p-3.5 px-4 text-sm font-semibold flex items-center justify-center gap-2 shadow-[0_4px_15px_rgba(4,97,254,0.3)] transition-all duration-300"
//         style={{
//           cursor: disabled ? "not-allowed" : "pointer",
//           opacity: disabled ? 0.7 : 1,
//         }}
//       >
//         {isRefreshing ? (
//           <Spinner size="tiny" />
//         ) : (
//           <>
//             <img
//               src="/assets/refresh-arrow.png"
//               alt="Refresh"
//               width={16}
//               height={16}
//               className="block"
//             />
//             <span className="font-semibold">{buttonText}</span>
//           </>
//         )}
//       </button>
//       {/* <p className="text-gray-500 text-xs m-0 mt-2 text-center">
//         Last updated on <span className="text-[#09CCA9]">{lastUpdated}</span>
//       </p> */}
//     </div>
//   );
// };

// interface DashboardTemplatesProps {
//   isGeneratingDashboard: boolean;
//   activeDashboard: string | null;
//   onGenerate: (type: string) => Promise<void>;
// }

// export const DashboardTemplates: React.FC<DashboardTemplatesProps> = ({
//   isGeneratingDashboard,
//   activeDashboard,
//   onGenerate,
// }) => {
//   const disabled = isGeneratingDashboard;

//   const cards: Array<{
//     key: string;
//     title: string;
//     subtitle: string;
//     icon: string;
//     gradient: string;
//     border: string;
//   }> = [
//     {
//       key: "Sales Performance Dashboard",
//       title: "Sales Dashboard",
//       subtitle: "Revenue, units sold and travel trends",
//       icon: "/assets/Sales Dashboard.png",
//       gradient: "linear-gradient(135deg, rgba(4,97,254,0.15), rgba(4,97,254,0.05))",
//       border: "#0461FE",
//     },
//     {
//       key: "Marketing Dashboard",
//       title: "Advertising Dashboard",
//       subtitle: "Campaign performance & metrics",
//       icon: "/assets/Add charts.png",
//       gradient: "linear-gradient(135deg, rgba(4,97,254,0.15), rgba(4,97,254,0.05))",
//       border: "#ec4899",
//     },
//     {
//       key: "Inventory Dashboard",
//       title: "Inventory Dashboard",
//       subtitle: "Inventory levels, sales trends, and more",
//       icon: "/assets/Inventory Dashboard.png",
//       gradient: "linear-gradient(135deg, rgba(16,185,129,0.15), rgba(16,185,129,0.05))",
//       border: "#10b981",
//     },
//     {
//       key: "SKU Harmonization Tool",
//       title: "SKU Harmonization tool",
//       subtitle: "Revenue, units sold and travel trends",
//       icon: "/assets/SKU Harmonization.png",
//       gradient: "linear-gradient(135deg, rgba(99,102,241,0.15), rgba(99,102,241,0.05))",
//       border: "#6366f1",
//     },
//   ];

//   const renderCard = (card: any) => {
//     const isActive = activeDashboard === card.key;
//     const isStatic =
//       card.key === "Sales Performance Dashboard" || card.key === "Inventory Dashboard";
//     return (
//       <button
//         key={card.key}
//         onClick={isStatic ? undefined : () => onGenerate(card.key)}
//         disabled={disabled}
//         className="w-full rounded-[14px] p-4 flex items-center gap-3 text-left text-gray-800 backdrop-blur-[10px] transition-all duration-300"
//         style={{
//           cursor: disabled ? "not-allowed" : "pointer",
//           background: isActive
//             ? "linear-gradient(180deg, rgba(255,255,255,0.70), rgba(255,255,255,0.55))"
//             : "rgba(255,255,255,0.3)",
//           border: `1px solid ${isActive ? "transparent" : "rgba(255,255,255,0.6)"}`,
//           boxShadow: isActive
//             ? `0 10px 25px rgba(0,0,0,0.10), 0 0 0 1px ${card.border}`
//             : "0 6px 16px rgba(0,0,0,0.08)",
//           opacity: disabled ? 0.7 : 1,
//           transform: isActive ? "translateY(-1px)" : undefined,
//         }}
//         onMouseEnter={(e) => {
//           e.currentTarget.style.boxShadow = "0 12px 28px rgba(0,0,0,0.12)";
//           e.currentTarget.style.transform = "translateY(-1px)";
//         }}
//         onMouseLeave={(e) => {
//           e.currentTarget.style.boxShadow = isActive
//             ? "0 10px 25px rgba(0,0,0,0.12)"
//             : "0 6px 16px rgba(0,0,0,0.08)";
//           e.currentTarget.style.transform = "translateY(0)";
//         }}
//       >
//         <div
//           className="w-10 h-10 rounded-[10px] flex items-center justify-center"
//           style={{ background: card.gradient }}
//         >
//           <img src={card.icon} alt="" width={24} height={24} className="object-contain" />
//         </div>
//         <div>
//           <div className="text-sm font-semibold text-gray-800">{card.title}</div>
//           <div className="text-xs text-gray-500 mt-0.5">{card.subtitle}</div>
//         </div>
//       </button>
//     );
//   };

//   return (
//     <div className="p-0 px-5 pb-3 flex-shrink-0 mt-5">
//       <h3 className="text-gray-800 text-sm font-semibold m-0 mb-3">Dashboard Templates</h3>
//       <div className="flex flex-col gap-3">{cards.map(renderCard)}</div>
//     </div>
//   );
// };

// interface ConnectionStatusProps {
//   isGeneratingDashboard: boolean;
// }

// export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ isGeneratingDashboard }) => {
//   return (
//     <div className="p-0 px-5 pb-5 flex-shrink-0 mt-auto">
//       <div className="bg-white/85 backdrop-blur-[10px] rounded-[14px] p-4 shadow-[0_6px_16px_rgba(0,0,0,0.08)] border border-white/70">
//         <div className="flex items-center mb-3">
//           <div className="w-7 h-7 rounded-lg bg-emerald-500/12 flex items-center justify-center mr-2">
//             <img
//               src="/assets/iconsax-wifi-square.png"
//               alt="Connected"
//               width={18}
//               height={18}
//               className="block"
//             />
//           </div>
//           <span className="text-gray-800 text-sm font-semibold flex items-center gap-2">
//             Status: <span className="text-emerald-500">Connected</span>
//             {isGeneratingDashboard ? <Spinner size="tiny" /> : null}
//           </span>
//         </div>
//         <ul className="list-none p-0 m-0 text-gray-900 text-[13px]">
//           <li className="flex items-center mb-2.5">
//             <span className="w-0 h-0 border-t-[4px] border-t-transparent border-b-[4px] border-b-transparent border-l-[6px] border-l-gray-900 mr-2.5"></span>
//             Amazon SP-API: Active
//           </li>
//           <li className="flex items-center mb-2.5">
//             <span className="w-0 h-0 border-t-[4px] border-t-transparent border-b-[4px] border-b-transparent border-l-[6px] border-l-gray-900 mr-2.5"></span>
//             Amazon SP-API: Active
//           </li>
//           <li className="flex items-center mb-2.5">
//             <span className="w-0 h-0 border-t-[4px] border-t-transparent border-b-[4px] border-b-transparent border-l-[6px] border-l-gray-900 mr-2.5"></span>
//             Amazon SP-API: Active
//           </li>
//           <li className="flex items-center mb-3">
//             <span className="w-0 h-0 border-t-[4px] border-t-transparent border-b-[4px] border-b-transparent border-l-[6px] border-l-gray-900 mr-2.5"></span>
//             Amazon SP-API: Active
//           </li>
//         </ul>
//         <div className="mt-2">
//           <div className="w-full bg-gray-200 rounded-md h-2 overflow-hidden">
//             <div className="bg-emerald-500 h-full w-full rounded-md"></div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

interface ModernTaskpaneProps {
  children: React.ReactNode;
}

export const WelcomeMessage: React.FC = () => {
  const [userName, setUserName] = React.useState<string | null>(null);

  React.useEffect(() => {
    let isMounted = true;

    const loadUserName = async () => {
      try {
        const storedName = await OfficeRuntime.storage.getItem("user_name");
        if (isMounted && storedName) {
          setUserName(storedName);
        }
      } catch (error) {
        console.error("Failed to load user name from storage:", error);
      }
    };

    loadUserName();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="flex-1 flex flex-col items-start px-5 pt-2">
      {/* Welcome Text */}
      <div className="text-left mb-3">
        <h1 className="text-[16px] font-semibold text-gray-800 leading-tight">
          Welcome{" "}
          <span className="text-[#068E75]">{userName || "Naveen"}</span>
          {" "}to Smart Grid
        </h1>
      </div>

      {/* Subtitle */}
      <p className="text-sm text-gray-500 text-left mb-5 leading-relaxed">
        Get started by selecting a dashboard template or exploring the available option from the ribbon.
      </p>

      {/* Ribbon Screenshot Card */}
      <div className="w-full">
        <div className="bg-white rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.08)] overflow-hidden border border-gray-100 relative">
          {/* Excel Ribbon Screenshot */}
          <img
            src="/assets/Mouse cursor.png"
            alt="Excel Ribbon with Spreetail Tools"
            className="w-full h-auto"
          />
        </div>
      </div>
    </div>
  );
};

export const ModernTaskpane: React.FC<ModernTaskpaneProps> = ({ children }) => {
  return (
    <>
      <style>
        {`
          .bg-gradient-custom {
            background: linear-gradient(180deg, #D3E8D9 0%, #EEEEEE 79.45%);
          }
          .bg-white-90 {
            background-color: rgba(255, 255, 255, 0.6);
          }
        `}
      </style>
      <div className="h-screen flex flex-col relative overflow-hidden font-sans text-gray-800 bg-gradient-custom">
        <div
          className="absolute -right-10 -top-10 w-50 h-50 blur-[40px] pointer-events-none"
          style={{
            background:
              "radial-gradient(circle at center, rgba(134, 239, 172, 0.3), transparent 70%)",
          }}
        ></div>
        <div
          className="absolute -left-8 -bottom-8 w-38 h-38 blur-[40px] pointer-events-none"
          style={{
            background:
              "radial-gradient(circle at center, rgba(167, 243, 208, 0.3), transparent 70%)",
          }}
        ></div>

        <SpreetailHeader />

        <div className="flex flex-col gap-3 overflow-y-auto">{children}</div>
      </div>
    </>
  );
};
